import clsx from "clsx"
import { FC } from "react"
import { CurrencyIcon } from "@/helpers/currencyIcon"
import { numberSpaceFixer } from "@/helpers/numberSpaceFixer"
import { useGetBalanceQuery } from "@/store/apis/balanceAPI"
import { Container } from "@/ui/Container"
import styles from "./BalancePill.module.scss"
import { IBalancePill } from "./types"

export const BalancePill: FC<IBalancePill> = ({ currency }) => {
  const { data: balance } = useGetBalanceQuery()
  const Icon = CurrencyIcon[currency]

  return (
    <Container className={clsx(styles.BalancePill, styles[currency])}>
      <div className={clsx(styles.BalancePill_icon)}>
        <Icon />
      </div>
      <div className={clsx(styles.BalancePill_value)}>
        {numberSpaceFixer(balance?.[currency], 2)}
      </div>
    </Container>
  )
}
